"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var splide_1 = require("@splidejs/splide");
var BrisachSlider = /** @class */ (function (_super) {
    __extends(BrisachSlider, _super);
    function BrisachSlider($view) {
        var _this = _super.call(this, $view) || this;
        _this.initSlideClassique();
        _this.initSlideMobile();
        return _this;
    }
    BrisachSlider.prototype.initSlideMobile = function () {
        var splide = new splide_1.default('#brisachSliderMobile', {
            start: 0,
            arrows: true,
        });
        splide.mount();
    };
    BrisachSlider.prototype.initSlideClassique = function () {
        var splide = new splide_1.default('#brisachSlider', {
            autoWidth: true,
            start: 1,
            arrows: false,
            trimSpace: false,
            focus: 'center',
        });
        splide.mount();
    };
    return BrisachSlider;
}(BaseComponent_1.default));
exports.default = BrisachSlider;
